"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = 'action';
exports.MENU = 'menu';
exports.ROLE_EVERYONE = '$everyone';
exports.ROLE_AUTHENTICATED = '$authenticated';
exports.ROLE_UNAUTHENTICATED = '$unauthenticated';
exports.ROLE_SUPERADMIN = 'superadmin';
exports.ROLE_READ_ALL = 'all.read';
exports.ROLE_READ_ALL_OF_CUSTOMER = 'allOfCustomer.read';
exports.ROLE_READ_ALL_OF_CHILD_CUSTOMER = 'allOfChildCustomer.read';
exports.ROLE_UPDATE_ROLE = 'role.update';
exports.ROLE_MENU_ALL = 'menu.all';
exports.ROLE_READ_CUSTOMER_TYPE = 'customerType.read';
exports.ROLE_READ_ALL_CUSTOMER_TYPE = 'customerType.readAll';
exports.ROLE_CREATE_CUSTOMER_TYPE = 'customerType.create';
exports.ROLE_UPDATE_CUSTOMER_TYPE = 'customerType.update';
exports.ROLE_DELETE_CUSTOMER_TYPE = 'customerType.delete';
exports.ROLE_READ_CUSTOMER = 'customer.read';
exports.ROLE_READ_ALL_CUSTOMER = 'customer.readAll';
exports.ROLE_CREATE_CUSTOMER = 'customer.create';
exports.ROLE_UPDATE_CUSTOMER = 'customer.update';
exports.ROLE_DELETE_CUSTOMER = 'customer.delete';
exports.ROLE_READ_PROFILE = 'profile.read';
exports.ROLE_READ_ALL_PROFILE = 'profile.readAll';
exports.ROLE_CREATE_PROFILE = 'profile.create';
exports.ROLE_UPDATE_PROFILE = 'profile.update';
exports.ROLE_DELETE_PROFILE = 'profile.delete';
exports.ROLE_READ_USER = 'user.read';
exports.ROLE_READ_ALL_USER = 'user.readAll';
exports.ROLE_CREATE_USER = 'user.create';
exports.ROLE_UPDATE_USER = 'user.update';
exports.ROLE_DELETE_USER = 'user.delete';
exports.ROLE_EXPORT_USER = 'user.export';
exports.ROLE_SET_ACTIVE_USER = 'user.setActive';
exports.ROLE_ENABLE_VERIFY_EMAIL_USER = 'user.enableVerifiedEmail';
exports.ROLE_SEND_EMAIL_USER = 'user.sendEmail';
exports.ROLE_UPDATE_INFO_USER = 'user.updateInfo';
exports.ROLE_RESET_PASSWORD_USER = 'user.resetPassword';
exports.ROLE_READ_PAYMENT = 'payment.read';
exports.ROLE_READ_ALL_PAYMENT = 'payment.readAll';
exports.ROLE_CREATE_PAYMENT = 'payment.create';
exports.ROLE_UPDATE_PAYMENT = 'payment.update';
exports.ROLE_DELETE_PAYMENT = 'payment.delete';
exports.ROLE_VERIFY_PAYMENT = 'payment.verify';
exports.ROLE_REJECT_PAYMENT = 'payment.reject';
exports.ROLE_READ_LOCATION = 'location.read';
exports.ROLE_READ_ALL_LOCATION = 'location.readAll';
exports.ROLE_CREATE_LOCATION = 'location.create';
exports.ROLE_UPDATE_LOCATION = 'location.update';
exports.ROLE_DELETE_LOCATION = 'location.delete';
exports.ROLE_EXPORT_LOCATION = 'location.export';
exports.ROLE_ACTIVE_CAMPAIGNS_LOCATION = 'location.activeCampaigns';
exports.ROLE_UPDATE_STATUS_LOCATION = 'location.updateStatus';
exports.ROLE_GET_HTML_CODE_LOCATION = 'location.getHTMLCode';
exports.ROLE_UPDATE_ADVANCE_LOCATION = 'location.updateAdvance';
exports.ROLE_UPDATE_BASIC_LOCATION = 'location.updateBasic';
exports.ROLE_UPDATE_SALE_INFO_LOCATION = 'location.updateSaleInfo';
exports.ROLE_UPDATE_SYSTEM_INFO_LOCATION = 'location.updateSystemInfo';
exports.ROLE_READ_CAMPAIGN = 'campaign.read';
exports.ROLE_READ_ALL_CAMPAIGN = 'campaign.readAll';
exports.ROLE_CREATE_CAMPAIGN = 'campaign.create';
exports.ROLE_UPDATE_CAMPAIGN = 'campaign.update';
exports.ROLE_DELETE_CAMPAIGN = 'campaign.delete';
exports.ROLE_EXPORT_CAMPAIGN = 'campaign.export';
exports.ROLE_MANAGE_SCHEDULE_CAMPAIGN = 'campaign.manageSchedule';
exports.ROLE_MANAGE_TIMES_CAMPAIGN = 'campaign.manageTimes';
exports.ROLE_MANAGE_KPI_CAMPAIGN = 'campaign.manageKpi';
exports.ROLE_MANAGE_LOCATION_CAMPAIGN = 'campaign.manageLocation';
exports.ROLE_MANAGE_PRIORITY_CAMPAIGN = 'campaign.managePriority';
exports.ROLE_SWAP_CAMPAIGN = 'campaign.swap';
exports.ROLE_MANAGE_RUNNING_CAMPAIGN = 'campaign.manageRunning';
exports.ROLE_BOOK_ONLINE_CAMPAIGN = 'campaign.bookOnline';
exports.ROLE_BOOK_CAMPAIGN = 'campaign.book';
exports.ROLE_APPROVE_CAMPAIGN = 'campaign.approve';
exports.ROLE_CONFIG_CAMPAIGN = 'campaign.config';
exports.ROLE_COPY_CAMPAIGN = 'campaign.copy';
exports.ROLE_ADVANCE_UPDATE_CAMPAIGN = 'campaign.updateAdvance';
exports.ROLE_GET_AVAILABLE_BOOKING_CAMPAIGN = 'campaign.getAvailableBooking';
exports.ROLE_CONFIG_REVENUE_CAMPAIGN = 'campaign.configRevenue';
exports.ROLE_VERIFY_REVENUE_CAMPAIGN = 'campaign.verifyRevenue';
exports.ROLE_READ_CAMPAIGN_MAPPING = 'campaignMapping.read';
exports.ROLE_READ_ALL_CAMPAIGN_MAPPING = 'campaignMapping.readAll';
exports.ROLE_CREATE_CAMPAIGN_MAPPING = 'campaignMapping.create';
exports.ROLE_UPDATE_CAMPAIGN_MAPPING = 'campaignMapping.update';
exports.ROLE_DELETE_CAMPAIGN_MAPPING = 'campaignMapping.delete';
exports.ROLE_READ_BANNER = 'banner.read';
exports.ROLE_READ_ALL_BANNER = 'banner.readAll';
exports.ROLE_CREATE_BANNER = 'banner.create';
exports.ROLE_UPDATE_BANNER = 'banner.update';
exports.ROLE_DELETE_BANNER = 'banner.delete';
exports.ROLE_CREATE_BANNER_TMP = 'bannerTmp.create';
exports.ROLE_READ_BANNER_TEMPLATE = 'bannerTemplate.read';
exports.ROLE_READ_ALL_BANNER_TEMPLATE = 'bannerTemplate.readAll';
exports.ROLE_CREATE_BANNER_TEMPLATE = 'bannerTemplate.create';
exports.ROLE_UPDATE_BANNER_TEMPLATE = 'bannerTemplate.update';
exports.ROLE_DELETE_BANNER_TEMPLATE = 'bannerTemplate.delete';
exports.ROLE_READ_IMAGE = 'image.read';
exports.ROLE_READ_ALL_IMAGE = 'image.readAll';
exports.ROLE_CREATE_IMAGE = 'image.create';
exports.ROLE_UPDATE_IMAGE = 'image.update';
exports.ROLE_DELETE_IMAGE = 'image.delete';
exports.ROLE_READ_EQUIPMENT = 'equipment.read';
exports.ROLE_READ_ALL_EQUIPMENT = 'equipment.readAll';
exports.ROLE_CREATE_EQUIPMENT = 'equipment.create';
exports.ROLE_UPDATE_EQUIPMENT = 'equipment.update';
exports.ROLE_DELETE_EQUIPMENT = 'equipment.delete';
exports.ROLE_EXPORT_EQUIPMENT = 'equipment.export';
exports.ROLE_GET_LOGIN_PAGE = 'equipment.loginPage';
exports.ROLE_READ_REVENUE = 'revenue.read';
exports.ROLE_READ_ALL_REVENUE = 'revenue.readAll';
exports.ROLE_CREATE_REVENUE = 'revenue.create';
exports.ROLE_UPDATE_REVENUE = 'revenue.update';
exports.ROLE_DELETE_REVENUE = 'revenue.delete';
exports.ROLE_REPORT_INCOME_BY_CAMPAIGN = 'reportIncome.trackingCampaign';
exports.ROLE_REPORT_INCOME_BY_LOCATION = 'reportIncome.trackingLocation';
exports.ROLE_REPORT_INCOME_PARTNER = 'reportIncome.partner';
exports.ROLE_EXPORT_REPORT_CAMPAIGN_LOCATION = 'reportCampaignLocation.export';
exports.ROLE_TRACKING_GRID_REPORT_CAMPAIGN_LOCATION = 'reportCampaignLocation.trackingGrid';
exports.ROLE_TRACKING_CHART_REPORT_CAMPAIGN_LOCATION = 'reportCampaignLocation.trackingChart';
exports.ROLE_STATS_REPORT_CAMPAIGN_LOCATION = 'reportCampaignLocation.stats';
exports.ROLE_INFO_REPORT_CAMPAIGN_LOCATION = 'reportCampaignLocation.info';
exports.ROLE_TRACKING_CHART_REPORT_LOCATION = 'reportLocation.trackingChart';
exports.ROLE_TRACKING_GRID_REPORT_LOCATION = 'reportLocation.trackingGrid';
exports.ROLE_EXPORT_REPORT_LOCATION = 'reportLocation.export';
exports.ROLE_TRACKING_REPORT_USER_RETURN = 'reportLocation.userReturn';
exports.ROLE_SHARED_TRAFFIC_CHART_REPORT_LOCATION = 'reportlocation.sharedTrafficChart';
exports.ROLE_SHARED_TRAFFIC_GRID_REPORT_LOCATION = 'reportlocation.sharedTrafficGrid';
exports.ROLE_EXPORT_REPORT_CAMPAIGN = 'reportCampaign.export';
exports.ROLE_OS_DEVICE_REPORT_CAMPAIGN = 'reportCampaign.osDevice';
exports.ROLE_CRM_REPORT_CAMPAIGN = 'reportCampaign.crm';
exports.ROLE_AUDIENCE_REPORT_CAMPAIGN = 'reportCampaign.audience';
exports.ROLE_TRACKING_GRID_REPORT_CAMPAIGN = 'reportCampaign.trackingGrid';
exports.ROLE_TRACKING_CHART_REPORT_CAMPAIGN = 'reportCampaign.trackingChart';
exports.ROLE_STATS_REPORT_CAMPAIGN = 'reportCampaign.stats';
exports.ROLE_INFO_REPORT_CAMPAIGN = 'reportCampaign.info';
exports.ROLE_CHART_TRACKING_PARTNER = 'reportCampaign.partnerCampaignChart';
exports.ROLE_AUDIENCE_DASHBOARD = 'dashboard.audience';
exports.ROLE_SESSION_DASHBOARD = 'dashboard.session';
exports.ROLE_TRAFFIC_OVERVIEW_DASHBOARD = 'dashboard.trafficOverview';
exports.ROLE_TRAFFIC_SUMMARY_DASHBOARD = 'dashboard.trafficSummary';
exports.ROLE_READ_OWNER = 'owner.read';
exports.ROLE_READ_ALL_OWNER = 'owner.readAll';
exports.ROLE_CREATE_OWNER = 'owner.create';
exports.ROLE_UPDATE_OWNER = 'owner.update';
exports.ROLE_DELETE_OWNER = 'owner.delete';
exports.ROLE_ASSIGN_PROFILE_OWNER = 'owner.assignProfile';
exports.ROLE_ASSIGN_USER_OWNER = 'owner.assignUser';
exports.ROLE_ASSIGN_LOCATION_OWNER = 'owner.assignLocation';
exports.ROLE_ASSIGN_CAMPAIGN_OWNER = 'owner.assignCampaign';
exports.ROLE_READ_REGION = 'region.read';
exports.ROLE_READ_ALL_REGION = 'region.readAll';
exports.ROLE_CREATE_REGION = 'region.create';
exports.ROLE_UPDATE_REGION = 'region.update';
exports.ROLE_DELETE_REGION = 'region.delete';
exports.ROLE_READ_COMMON = 'common.read';
exports.ROLE_READ_ALL_COMMON = 'common.readAll';
exports.ROLE_CREATE_COMMON = 'common.create';
exports.ROLE_UPDATE_COMMON = 'common.update';
exports.ROLE_DELETE_COMMON = 'common.delete';
exports.ROLE_READ_FILE = 'file.read';
exports.ROLE_READ_ALL_FILE = 'file.readAll';
exports.ROLE_CREATE_FILE = 'file.create';
exports.ROLE_UPDATE_FILE = 'file.update';
exports.ROLE_DELETE_FILE = 'file.delete';
exports.ROLE_READ_MESSAGE = 'message.read';
exports.ROLE_READ_ALL_MESSAGE = 'message.readAll';
exports.ROLE_CREATE_MESSAGE = 'message.create';
exports.ROLE_UPDATE_MESSAGE = 'message.update';
exports.ROLE_DELETE_MESSAGE = 'message.delete';
exports.ROLE_READ_NOTIFICATION = 'notification.read';
exports.ROLE_READ_ALL_NOTIFICATION = 'notification.readAll';
exports.ROLE_CREATE_NOTIFICATION = 'notification.create';
exports.ROLE_UPDATE_NOTIFICATION = 'notification.update';
exports.ROLE_DELETE_NOTIFICATION = 'notification.delete';
exports.ROLE_READ_INTRUCTION = 'intruction.read';
exports.ROLE_READ_ALL_INTRUCTION = 'intruction.readAll';
exports.ROLE_CREATE_INSTRUCTION = 'intruction.create';
exports.ROLE_UPDATE_INSTRUCTION = 'intruction.update';
exports.ROLE_DELETE_INTRUCTION = 'intruction.delete';
exports.ROLE_READ_PRICING = 'pricing.read';
exports.ROLE_READ_ALL_PRICING = 'pricing.readAll';
exports.ROLE_CREATE_PRICING = 'pricing.create';
exports.ROLE_UPDATE_PRICING = 'pricing.update';
exports.ROLE_DELETE_PRICING = 'pricing.delete';
exports.ROLE_READ_LOGS = 'logs.read';
exports.ROLE_MENU_DASHBOARD = 'dashboard';
exports.ROLE_MENU_LOCATION = 'location.access';
exports.ROLE_MENU_EQUIPMENTS = 'equipments.access';
exports.ROLE_MENU_CAMPAIGNS_PRIORITY = 'campaignPriority.access';
exports.ROLE_MENU_SWAP_CAMPAIGN = 'swapCampaign.access';
exports.ROLE_MENU_AVAILABLE_KPI = 'availableKpi.access';
exports.ROLE_MENU_ACTIVE_CAMPAIGNS = 'activeCampaigns.access';
exports.ROLE_MENU_CAMPAIGNS = 'campaigns.access';
exports.ROLE_MENU_KPI_MANAGEMENT = 'kpiManagement.access';
exports.ROLE_MENU_BOOKING_ONLINE = 'bookingOnline.access';
exports.ROLE_MENU_BANNER = 'banner.access';
exports.ROLE_MENU_BOOK_CAMPAIGN = 'bookCampaign.access';
exports.ROLE_MENU_CAMPAIGN_CONFIG = 'campaignConfig.access';
exports.ROLE_MENU_REVENUE_CONFIG = 'revenueConfig.access';
exports.ROLE_MENU_REPORT_CAMPAIGN = 'reportCampaign.access';
exports.ROLE_MENU_REPORT_CAMPAIGN_PARTNER = 'reportCampaignPartner.access';
exports.ROLE_MENU_REPORT_LOCATION = 'reportLocation.access';
exports.ROLE_MENU_REPORT_USER_RETURN = 'reportUserReturnLocation.access';
exports.ROLE_MENU_REPORT_REVENUE = 'reportRevenue.access';
exports.ROLE_MENU_REPORT_CAMPAIGN_LOCATION = 'reportCampaignLocation.access';
exports.ROLE_MENU_ACCOUNTS = 'accounts.access';
exports.ROLE_MENU_MY_PROFILE = 'myProfile.access';
exports.ROLE_MENU_PROFILE = 'profile.access';
exports.ROLE_MENU_ASSIGN_CAMPAIGN = 'assignCampaign.access';
exports.ROLE_MENU_ASSIGN_LOCATION = 'assignLocation.access';
exports.ROLE_MENU_ASSIGN_PROFILE = 'assignProfile.access';
exports.ROLE_MENU_CUSTOMER_TYPE = 'customerType.access';
exports.ROLE_MENU_CUSTOMER = 'customer.access';
exports.ROLE_MENU_COMMON_DATA = 'commondata.access';
exports.ROLE_MENU_BANNER_IMAGE = 'bannerImage.access';
exports.ROLE_MENU_BANNER_TEMPLATE = 'bannerTemplate.access';
exports.ROLE_MENU_EQUIPMENT_MODEL = 'equipmentModel.access';
exports.ROLE_MENU_EQUIPMENT_BRAND = 'equipmentBrand.access';
exports.ROLE_MENU_LOCATION_TAGS = 'locationTags.access';
exports.ROLE_MENU_CAMPAIGN_BRAND = 'campaignBrand.access';
exports.ROLE_MENU_CATEGORY_GROUPS = 'groupCategory.access';
exports.ROLE_MENU_INSTRUCTION = 'instruction.access';
exports.ROLE_MENU_EQUIPMENT_GROUP = 'groupEquipment.access';
exports.ROLE_MENU_LOCATION_CATEGORY = 'locationCategory.access';
exports.ROLE_REPORT_HOTSPOT = 'reportHotspot.access';
exports.ROLE_MENU_INCOME_CAMPAIGN = 'reportIncomeByCampaign.access';
exports.ROLE_MENU_INCOME_LOCATION = 'reportIncomeByLocation.access';
exports.ROLE_MENU_INCOME_PARTNER = 'reportIncomeForPartner.access';
exports.ROLE_MENU_SETTING_REGION = 'region.access';
exports.ROLE_MENU_MANAGEMENT_PAYMENT = 'payment.access';
exports.ROLE_MENU_PRICING = 'pricing.access';
exports.ROLE_MENU_LOGS = 'logs.access';
exports.ROLE_SHOW_FILTER_OWNER_TYPE = 'filter.ownerType';
exports.ROLE_SHOW_FILTER_CATEGORY = 'filter.category';
//# sourceMappingURL=roles.js.map